var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLastUpdate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#F9EAC6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8333 9.33325H11.1667C10.2462 9.33325 9.5 10.0794 9.5 10.9999V22.6666C9.5 23.5871 10.2462 24.3333 11.1667 24.3333H22.8333C23.7538 24.3333 24.5 23.5871 24.5 22.6666V10.9999C24.5 10.0794 23.7538 9.33325 22.8333 9.33325Z",
    stroke: "#FFB600",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3333 7.66675V11.0001",
    stroke: "#FFB600",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 7.66675V11.0001",
    stroke: "#FFB600",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14.3333H24.5",
    stroke: "#FFB600",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastUpdate);
export default __webpack_public_path__ + "static/media/lastUpdate.047cb96025bda60e4b65903dd6eb77e5.svg";
export { ForwardRef as ReactComponent };